enum OrderJoinOrderDetailsMapMarkerType {
  ONBOARDING = "ONBOARDING",
  OUTBOARDING = "OUTBOARDING",
  STANDARD = "STANDARD",
  WEATHERED = "WEATHERED",
}

export default OrderJoinOrderDetailsMapMarkerType;
